import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ShipmentDetailsLineItem from '../../../line-item/shipment-details-item';
import { emptyArray } from 'ui-components/default-props/empty';

import style from './shipment-details-modal-content.module.less';

const renderShipmentItemsText = () => (
  <FormattedMessage defaultMessage='Shipment Items' description='shipmentDetails.content.shipmentItemsTitle' id='c9qa3p' />
);

const renderNoItemsMessage = () => (
  <div>
    <div className={style['item-section-title']}>{renderShipmentItemsText()}</div>
    <div />
    <div className={style['no-items-message']}>
      <FormattedMessage defaultMessage='There are no items' description='shipmentDetails.content.noItems' id='iR5/7T' />
    </div>
  </div>
);
const findSalesOrderItems = (order = { items: [] }, items) => {
  const matchedItems = [];

  items.forEach((item) => {
    const match = order.items.find((orderItem) => orderItem.salesOrderItemId === item.salesOrderItemId);
    if (match) {
      matchedItems.push(match);
    }
  });

  return matchedItems;
};

export const ShipmentDetailsItems = ({ items = emptyArray, salesOrders = emptyArray }) => {
  if (!items.length) {
    return renderNoItemsMessage();
  }

  if (salesOrders.length < 2) {
    return (
      <div className={style['order-info-items']}>
        <div className={style['item-section-title']}>{renderShipmentItemsText()}</div>
        <div className={style.header}>
          <FormattedMessage defaultMessage='Qty' description='shipmentDetails.content.shipmentItemsQuantity' id='EzYOVX' />
        </div>
        {items.map((item) => {
          return <ShipmentDetailsLineItem key={item.salesOrderItemId} orderItem={item} />;
        })}
      </div>
    );
  }

  return (
    <div className={style['order-info-items']}>
      <div className={style['item-section-title']}>{renderShipmentItemsText()}</div>
      <div className={style.white} />
      {salesOrders.map((order) => {
        return (
          <React.Fragment key={order.salesOrderId}>
            <div className={style['combo-order-section']}>
              <div className={style['combo-order-number']} title={order.orderNumber}>
                <FormattedMessage
                  defaultMessage='Items from Order #{orderNumber}'
                  description='shipmentDetails.comboItem'
                  id='kBTWxz'
                  values={{ orderNumber: order.orderNumber }}
                />
              </div>
            </div>
            <div className={style.header}>
              <FormattedMessage defaultMessage='Qty' description='shipmentDetails.content.shipmentItemsQuantity' id='EzYOVX' />
            </div>
            {findSalesOrderItems(order, items).map((matchingItem) => (
              <ShipmentDetailsLineItem key={matchingItem.salesOrderItemId} orderItem={matchingItem} />
            ))}
          </React.Fragment>
        );
      })}
    </div>
  );
};

ShipmentDetailsItems.propTypes = {
  items: PropTypes.array,
  salesOrders: PropTypes.array,
};
